import React, { useCallback, useRef } from 'react';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import Swal from 'sweetalert2';

import { useHistory, useParams } from 'react-router-dom';
import getValidationErros from '~/utils/getValidationsErrors';

import { Container } from './styles';
import Input from '~/components/Input';

import logo from '~/assets/logos/logo-name.svg';
import api from '~/services/api';
import Toast from '~/utils/toast';

interface IFormData {
  password: string;
}

interface IParams {
  token: string;
}

const ForgotPassword: React.FC = () => {
  const history = useHistory();
  const params = useParams<IParams>();
  const formRef = useRef<FormHandles>(null);

  const handleSubmit = useCallback(
    async (data: IFormData) => {
      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          password: Yup.string().required('A senha é obrigatório'),
          confirm_password: Yup.string().oneOf(
            [Yup.ref('password'), null],
            'As senhas devem ser iguais'
          ),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        const formData = {
          token: params.token,
          password: data.password,
        };

        await api.post('users/sessions/change-password', formData);

        Toast.fire({
          icon: 'success',
          iconColor: '#ff6900',
          title: 'Senha alterada com sucesso!',
        });

        history.push(`${process.env.PUBLIC_URL}`);
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErros(error);
          formRef.current?.setErrors(errors);
        } else {
          Swal.fire('Oops...', 'Ocorreu um erro tente novamente, por favor');
        }
      }
    },
    [history, params.token]
  );

  return (
    <Container>
      <div className="container h-100">
        <div className="row justify-content-center">
          <div className="col-12 text-center">
            <div className="ret-up ret-left d-none d-lg-block" />
            <div className="ret-up ret-right d-none d-lg-block" />
            <img src={logo} alt="Logo Koro" className="logo" />
          </div>

          <div className="col-lg-4 px-3">
            <h2 className="h6 text-white fw-normal mb-3">
              Insira sua nova senha e repita ela para confirmar
            </h2>
            <Form
              ref={formRef}
              onSubmit={handleSubmit}
              className="d-flex flex-column pb-3"
            >
              <label className="mb-3">
                <span className="text-white fw-normal d-block mb-2 size">
                  Nova senha
                </span>
                <Input type="password" name="password" />
              </label>

              <label className="mb-3">
                <span className="text-white fw-normal d-block mb-2 size">
                  Confirmar senha
                </span>
                <Input type="password" name="confirm_password" />
              </label>

              <button
                type="submit"
                className="btn btn-login h6 fw-normal py-2 mt-4"
              >
                Enviar
              </button>
            </Form>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ForgotPassword;
